import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ConfirmationModalComponent } from "ui-kit";

@Injectable({ providedIn: "root" })
export class UnsavedChangesService {
  private readonly modalSvc = inject(NgbModal);

  confirmLeave(): Observable<boolean> {
    const modal = this.modalSvc.open(ConfirmationModalComponent, {
      backdrop: "static",
      size: "md",
      centered: true,
      windowClass: "custom confirm"
    });
    const confirmation: ConfirmationModalComponent = modal.componentInstance;
    confirmation.title = "common.unsavedChanges.title";
    confirmation.message = "common.unsavedChanges.message";
    confirmation.icon = "mdi-alert-outline";
    confirmation.tone = "warning";
    confirmation.confirmBtnText = "common.controls.leave";

    return from(modal.result).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
